import i18next from 'i18next';

i18next.addResources('es_CL', 'PickCommune', {
  where: '¿Dónde quieres comprar hoy?',
  betterExpierence: 'Para entregarte una mejor experiencia, selecciona la comuna en donde te encuentres',
  enterCommune: 'Ingresa una comuna',
  selectCommune: 'Selecciona tu comuna',
  confirm: 'Confirmar ubicación'
});
